import { render, staticRenderFns } from "./AssetEstatePlanning.vue?vue&type=template&id=5871c8eb"
import script from "./AssetEstatePlanning.vue?vue&type=script&lang=js"
export * from "./AssetEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports